import React, { Component } from 'react';
import { Container, Row, Col } from 'react-grid-system';

import classNames from 'classnames';
import { isKeyDownEnter, isTargetInput } from 'helpers/Event';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import DeepSearchService from 'modules/userManager/userSearch/deepSearch/DeepSearchService';
import DeepSearchStore from 'modules/userManager/userSearch/deepSearch/DeepSearchStore';
import PropTypes from 'prop-types';

import DeepSearchAccess from './access/DeepSearchAccess';
import DeepSearchContent from './content/DeepSearchContent';
import DeepSearchFooter from './DeepSearchFooter';
import DeepSearchMenu from './DeepSearchMenu';
import DeepSearchUser from './user/DeepSearchUser';

import './DeepSearch.scss';

const contentBySelectedMenu = {
  content: DeepSearchContent,
  access: DeepSearchAccess,
  user: DeepSearchUser
};

@inject((stores) => ({
  menuSelected: stores.DeepSearchStore.menuSelected
}))
@observer
export default class DeepSearch extends Component {
  static propTypes = {
    className: PropTypes.string,
    disableErrorFields: PropTypes.func,
    enableErrorFields: PropTypes.func,
    error: PropTypes.bool,
    menuSelected: MobxPropTypes.objectOrObservableObject,
    searchUsers: PropTypes.func,
    onClearFilters: PropTypes.func,
    hideSegmentationOptions: PropTypes.bool,
    submitButtonLabel: PropTypes.string
  };

  updateSelectedMenu(menu) {
    const { enableErrorFields, disableErrorFields } = this.props;

    if (DeepSearchStore.errorFields) {
      enableErrorFields();
    } else {
      disableErrorFields();

      DeepSearchService.setMenuSelected(menu);
    }
  }

  onClearFilters = () => {
    const { onClearFilters } = this.props;

    DeepSearchService.clearFiltersByCallback(onClearFilters);
  };

  setClearFunctionReference = (key, clearFunction) =>
    DeepSearchService.setClearFunctionReference(key, clearFunction);

  unsetClearFunctionReference = (key) =>
    DeepSearchService.unsetClearFunctionReference(key);

  trackKeyEvent = (event) => {
    const isEnterkey = isKeyDownEnter(event);
    const isInput = isTargetInput(event);

    if (isEnterkey && !isInput) {
      this.searchUsers();
    }
  };

  searchUsers = () => {
    const { searchUsers } = this.props;

    searchUsers && searchUsers();
  };

  render() {
    const {
      className,
      error,
      menuSelected,
      hideSegmentationOptions,
      submitButtonLabel
    } = this.props;

    const classes = classNames(
      'users__form p__0 deep__search__container',
      className
    );

    return (
      <Container
        fluid
        className={classes}
        onKeyDown={this.trackKeyEvent}
        tabIndex="0"
      >
        <Row className="deep__search__container__content" nogutter>
          <div className="deep__search__container__menu">
            <DeepSearchMenu
              updateSelectedMenu={this.updateSelectedMenu.bind(this)}
              menuSelected={menuSelected}
            />
          </div>

          {Object.keys(menuSelected).map((menu) => {
            const Content = contentBySelectedMenu[menu];

            return (
              menuSelected[menu] && (
                <Col sm={12} md={9} className="deep__search__container__search">
                  <Content
                    error={error}
                    setClearFunction={this.setClearFunctionReference}
                    unsetClearFunction={this.unsetClearFunctionReference}
                  />
                </Col>
              )
            );
          })}
        </Row>

        <DeepSearchFooter
          onClearFilters={this.onClearFilters}
          searchUsers={this.searchUsers}
          hideSegmentationOptions={hideSegmentationOptions}
          submitButtonLabel={submitButtonLabel}
        />
      </Container>
    );
  }
}
